module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_chopvalue_1.3086b119.jpg";